{
    "name": "monsido_frontend",
    "description": "Frontend for monsido",
    "version": "1.12.17",
    "engines": {
        "node": ">=22.14.0"
    },
    "scripts": {
        "serve": "yarn serve:dev",
        "serve:dev": "node scripts/serve.js --watch --env=development",
        "serve:staging": "node scripts/serve.js --env=development",
        "serve:pentest": "node scripts/serve.js --env=pentest",
        "serve:production": "node scripts/serve.js --env=production",
        "build:dev": "node --max_old_space_size=2048 scripts/build.js --env=development",
        "build:staging": "node --max_old_space_size=2048 scripts/build.js --env=staging",
        "build:pentest": "node --max_old_space_size=2048 scripts/build.js --env=pentest",
        "build:production": "node --max_old_space_size=2048 scripts/build.js --env=production",
        "pretest": "yarn puppeteer browsers install chrome",
        "test": "node scripts/test.js --testMode=modern && yarn test:jest",
        "test:jasmine": "node scripts/test.js --testMode=modern",
        "test:legacy": "node scripts/test.js --testMode=legacy",
        "test:ci": "node scripts/test.js --testMode=allCi && yarn test:jest --runInBand",
        "test:leg": "node scripts/test.js --testMode=legacyCi",
        "test:cc": "node scripts/test.js --testMode=cc",
        "test:a11y": "node scripts/test.js --testMode=a11y",
        "test:jest": "jest",
        "test:jest:cc": "jest --coverage",
        "test:jest:fast": "jest --maxWorkers=50% --onlyChanged --passWithNoTests",
        "test:jest:watch": "jest --maxWorkers=50% --onlyChanged --passWithNoTests --watch",
        "test:coverage": "yarn test:cc && yarn test:jest:cc",
        "lint": "yarn lint:ts",
        "lint:ts": "eslint \"src/client/ng2/**/*.ts\"",
        "lint:js": "eslint \"src/client/app/**/*.js\"",
        "translate:extract:ts": "angular-gettext-cli --files '{./src/client/deprecate/frontend-components/src/**/*.+(js|html),./src/client/deprecate/ng-mon-dialog/**/*.+(js),./node_modules/@monsido/angular-shared-components/projects/angular-shared-components/src/**/*.+(html|ts),./src/client/**/*.+(js|html|ts)}' --exclude {'./src/client/angularjs-app.js,./src/client/**/*.spec.js'} --dest './translation/base.pot' --marker-names 'translate,[translate],getString,getPlural,translate-context,translate-plural,translate-comment,translate-args'",
        "translate:compile": "angular-gettext-cli --compile --files './translation/translations/*.po' --dest './src/client/app/modules/translations/run/translations.run.js' --format javascript --module modules.translations.run",
        "translate:compile:json": "angular-gettext-cli --compile --files './translation/translations/*.po' --dest './src/client/ng2/core/translation/translations.json' --format json",
        "translate:poedit:get": "node node_modules/@monsido_services/services/mon-poeditor/dist --config='./translation-config.json' --extract",
        "translate:poedit:sync": "node node_modules/@monsido_services/services/mon-poeditor/dist --config='./translation-config.json' --sync",
        "t:p:ts": "yarn translate:extract:ts && yarn translate:poedit:sync",
        "t:d:ts": "yarn translate:poedit:get && yarn translate:compile && yarn translate:compile:json",
        "bump": "yarn version --patch --no-git-tag-version",
        "bump:minor": "yarn version --minor --no-git-tag-version",
        "bump:major": "yarn version --major --no-git-tag-version",
        "analyze-upgrade": "ts-node ./ng-upgrade-analyzer/src/index.ts",
        "audits": "[ -f audits.json ] && rm audits.json; yarn npm audit --all --recursive --json >> audits.json",
        "peers": "[ -f peers-failed.txt ] && rm peers-failed.txt; yarn explain peer-requirements | grep ✘ >> peers-failed.txt"
    },
    "dependencies": {
        "@angular/animations": "18.2.6",
        "@angular/cdk": "18.2.6",
        "@angular/common": "18.2.6",
        "@angular/compiler": "18.2.6",
        "@angular/core": "18.2.6",
        "@angular/forms": "18.2.6",
        "@angular/localize": "18.2.6",
        "@angular/platform-browser": "18.2.6",
        "@angular/platform-browser-dynamic": "18.2.6",
        "@angular/router": "18.2.6",
        "@angular/upgrade": "18.2.6",
        "@fortawesome/fontawesome-pro": "5.15.4",
        "@iamadamjowett/angular-click-outside": "2.10.1",
        "@monsido/angular-shared-components": "git+ssh://git@github.com/Monsido/angular-shared-components.git#4.0.2",
        "@monsido/colors": "git+ssh://git@github.com/Monsido/frontend-color-schemas.git#1.0.7",
        "@monsido/consent-message-encoder": "git+ssh://git@github.com/Monsido/mon-consent-message-encoder.git#0.0.6",
        "@monsido_services/services": "git+ssh://git@github.com/Monsido/mon-services.git#1.2.3",
        "@ng-bootstrap/ng-bootstrap": "17.0.1",
        "@popperjs/core": "2.11.8",
        "@uirouter/angular": "14.0.0",
        "@uirouter/angular-hybrid": "18.0.0",
        "@uirouter/angularjs": "1.1.1",
        "@uirouter/core": "6.1.1",
        "@uirouter/rx": "1.0.0",
        "angular": "1.8.3",
        "angular-animate": "1.8.3",
        "angular-aria": "1.8.3",
        "angular-bind-html-compile": "1.4.1",
        "angular-cache": "4.6.0",
        "angular-chart.js": "1.1.1",
        "angular-color-picker": "1.0.10",
        "angular-drag-and-drop-lists": "2.1.0",
        "angular-environment": "1.0.8",
        "angular-gettext": "git+ssh://git@github.com/Monsido/angular-gettext.git#htmlparams2",
        "angular-gettext-cli": "1.2.0",
        "angular-hotkeys": "chieffancypants/angular-hotkeys#1.7.0",
        "angular-inview": "3.1.0",
        "angular-moment": "1.3.0",
        "angular-numeraljs": "2.0.1",
        "angular-sanitize": "1.8.3",
        "angular-ui-bootstrap": "2.5.6",
        "bootstrap": "5.3.3",
        "chart.js": "2.9.4",
        "deepmerge": "4.3.1",
        "dompurify": "3.2.4",
        "flag-icons": "7.2.3",
        "focus-trap": "7.6.0",
        "moment": "2.30.1",
        "ng-click-outside2": "16.0.0",
        "ng-csv": "0.3.6",
        "ng-device-detector": "4.0.3",
        "ng-dialog": "1.4.0",
        "ng-infinite-scroll": "1.3.0",
        "ng-rollbar": "2.4.2",
        "ng-tags-input": "3.2.0",
        "ngstorage": "0.3.11",
        "numeral": "2.0.6",
        "papaparse": "5.3.2",
        "privacy_terms": "git+ssh://git@github.com/Monsido/privacy_terms.git#20231102.3",
        "roboto-fontface": "0.10.0",
        "rollbar": "2.26.2",
        "rx-angular": "1.1.3",
        "rxjs": "6.6.7",
        "tslib": "^2.8.1",
        "zone.js": "0.14.10"
    },
    "devDependencies": {
        "@angular-builders/custom-webpack": "18.0.0",
        "@angular-devkit/build-angular": "~18.2.6",
        "@angular-devkit/core": "18.2.6",
        "@angular/cli": "18.2.6",
        "@angular/compiler-cli": "18.2.6",
        "@angular/language-service": "18.2.6",
        "@iplab/ngx-color-picker": "18.0.1",
        "@jest/globals": "29.7.0",
        "@monsido/eslint-config-typescript": "git+ssh://git@github.com/Monsido/eslint-config-typescript.git#2.0.1",
        "@stylistic/eslint-plugin": "2.9.0",
        "@types/angular": "1.8.4",
        "@types/chart.js": "2.9.41",
        "@types/jasmine": "3.6.0",
        "@types/jasminewd2": "2.0.10",
        "@types/jest": "29.5.14",
        "@types/jquery": "3.5.14",
        "@types/lodash": "4.14.168",
        "@types/node": "18.11.9",
        "@types/numeral": "2.0.5",
        "@types/webpack-env": "1.18.0",
        "@typescript-eslint/eslint-plugin": "8.9.0",
        "@typescript-eslint/parser": "8.9.0",
        "angular-eslint": "19.3.0",
        "angular-mocks": "1.8.3",
        "axe-core": "4.10.0",
        "bardjs": "https://github.com/Monsido/bardjs#0.1.9",
        "chokidar": "3.6.0",
        "concurrently": "8.2.1",
        "connect-history-api-fallback": "2.0.0",
        "del": "7.1.0",
        "eslint": "9.12.0",
        "fs": "0.0.1-security",
        "html-minifier-terser": "7.2.0",
        "jasmine-core": "4.5.0",
        "jasmine-expect": "5.0.0",
        "jest": "29.7.0",
        "jest-preset-angular": "14.4.1",
        "jsdom": "26.1.0",
        "karma": "6.4.4",
        "karma-chrome-launcher": "3.2.0",
        "karma-coverage": "2.2.1",
        "karma-jasmine": "5.1.0",
        "karma-sinon": "1.0.5",
        "karma-spec-reporter": "0.0.36",
        "lodash": "4.17.21",
        "marked": "14.1.2",
        "ng-mocks": "14.13.1",
        "node-html-parser": "6.1.13",
        "node-notifier": "10.0.1",
        "puppeteer": "23.5.0",
        "require-dir": "1.2.0",
        "sinon": "20.0.0",
        "ts-jest": "29.2.5",
        "ts-node": "10.9.2",
        "typescript": "5.4.2",
        "typescript-eslint": "8.9.0",
        "yargs": "17.7.2"
    },
    "peerDependencies": {
        "@uirouter/angularjs": "1.1.0",
        "angular": "1.8.3",
        "angular-mocks": "1.8.3",
        "ng-device-detector": "3.0.1"
    },
    "resolutions": {
        "ua-parser-js": "1.0.33",
        "nth-check": ">=2.0.3",
        "esbuild": "^0.25.0",
        "lodash": "^4.17.21",
        "http-proxy-middleware": "^3.0.5",
        "cheerio": "^1.0.0-rc.12",
        "critters": "npm:beasties@latest",
        "abab": "npm:@xmldom/xmldom@latest",
        "domexception": "^4.0.0",
        "angular-chart.js/chart.js": "^2.9.4"
    },
    "packageManager": "yarn@4.9.1"
}
